import { Helpers } from '../../helpers';
import { ITargetFormation } from '../../interfaces/itarget-formation';
import { AreaTargetFormation } from '../area-target-formation';
import { AreaTargetFormationFactor } from '../area-target-formation-factor';
import { AssetTeam } from '../asset-team';
import { AutoMappingCombiningTargetFormation } from '../auto-mapping-combining-target-formation';
import { AutoRelationship } from '../auto-relationship';
import { ConstraintDrillFracInterferenceDetail } from '../constraint-drill-frac-interference-detail';
import { ConstraintDrillFracInterferenceInteractingTargetFormation } from '../constraint-drill-frac-interference-interacting-target-formation';
import { ConstraintPrematureWellShutdownDetail } from '../constraint-premature-well-shutdown-detail';
import { ConstraintPrematureWellShutdownInteractingTargetFormation } from '../constraint-premature-well-shutdown-interacting-target-formation';
import { ContinuousDrillingObligation } from '../continuous-drilling-obligation';
import { FormationTop } from '../formation-top';
import { LandingPoint } from '../landing-point';
import { TypeCurve } from '../type-curve';
import { Well } from '../well';

export class TargetFormationBase {
  TargetFormationId: number;
  Description: string;
  Alias: string | null;
  Alias2: string | null;
  PlugsPerDay: number | null;
  SortOrder: number | null;
  PlugsPerDayPullingUnit: number | null;
  PlugsPerDayCoilTubing: number | null;
  TreatingPressure: number | null;
  CostMatrixInput: boolean;
  Color: string | null;
  AssetTeamId: number;
  PlugsPerDayCoilTubingAndNitrogen: number | null;
  PlugsPerDayWorkoverSaltSystem: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  FormationTopName: string | null;
  IsPermianDeepFormation: boolean;

  AreaTargetFormationFactors_TargetFormation?: Array<AreaTargetFormationFactor> | null;
  AreaTargetFormations_TargetFormation?: Array<AreaTargetFormation> | null;
  AutoMappingCombiningTargetFormations_TargetFormation?: Array<AutoMappingCombiningTargetFormation> | null;
  ConstraintDrillFracInterferenceDetails_TargetFormation?: Array<ConstraintDrillFracInterferenceDetail> | null;
  ConstraintPrematureWellShutdownDetails_TargetFormation?: Array<ConstraintPrematureWellShutdownDetail> | null;
  ContinuousDrillingObligations_TargetFormation?: Array<ContinuousDrillingObligation> | null;
  FormationTops_TargetFormation?: Array<FormationTop> | null;
  LandingPoints_TargetFormation?: Array<LandingPoint> | null;
  TypeCurves_TargetFormation?: Array<TypeCurve> | null;
  Wells_TargetFormation?: Array<Well> | null;
  AreaTargetFormations_TargetFormationAllowed?: Array<AreaTargetFormation> | null;
  AutoMappingCombiningTargetFormations_CombiningTargetFormation?: Array<AutoMappingCombiningTargetFormation> | null;
  AutoRelationships_PrecedingFracGroupTargetFormation?: Array<AutoRelationship> | null;
  AutoRelationships_SucceedingFracGroupTargetFormation?: Array<AutoRelationship> | null;
  ConstraintDrillFracInterferenceInteractingTargetFormations_InteractingTargetFormation?: Array<ConstraintDrillFracInterferenceInteractingTargetFormation> | null;
  ConstraintPrematureWellShutdownInteractingTargetFormations_InteractingTargetFormation?: Array<ConstraintPrematureWellShutdownInteractingTargetFormation> | null;
  AssetTeam?: AssetTeam;

  constructor(item?: ITargetFormation) {
    if (item) {

      this.TargetFormationId = item.TargetFormationId;
      this.Description = item.Description;
      this.Alias = item.Alias;
      this.Alias2 = item.Alias2;
      this.PlugsPerDay = item.PlugsPerDay;
      this.SortOrder = item.SortOrder;
      this.PlugsPerDayPullingUnit = item.PlugsPerDayPullingUnit;
      this.PlugsPerDayCoilTubing = item.PlugsPerDayCoilTubing;
      this.TreatingPressure = item.TreatingPressure;
      this.CostMatrixInput = item.CostMatrixInput;
      this.Color = item.Color;
      this.AssetTeamId = item.AssetTeamId;
      this.PlugsPerDayCoilTubingAndNitrogen = item.PlugsPerDayCoilTubingAndNitrogen;
      this.PlugsPerDayWorkoverSaltSystem = item.PlugsPerDayWorkoverSaltSystem;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.FormationTopName = item.FormationTopName;
      this.IsPermianDeepFormation = item.IsPermianDeepFormation;

      this.AreaTargetFormationFactors_TargetFormation = Helpers.createClassArray(AreaTargetFormationFactor, item.AreaTargetFormationFactors_TargetFormation);
      this.AreaTargetFormations_TargetFormation = Helpers.createClassArray(AreaTargetFormation, item.AreaTargetFormations_TargetFormation);
      this.AutoMappingCombiningTargetFormations_TargetFormation = Helpers.createClassArray(AutoMappingCombiningTargetFormation, item.AutoMappingCombiningTargetFormations_TargetFormation);
      this.ConstraintDrillFracInterferenceDetails_TargetFormation = Helpers.createClassArray(ConstraintDrillFracInterferenceDetail, item.ConstraintDrillFracInterferenceDetails_TargetFormation);
      this.ConstraintPrematureWellShutdownDetails_TargetFormation = Helpers.createClassArray(ConstraintPrematureWellShutdownDetail, item.ConstraintPrematureWellShutdownDetails_TargetFormation);
      this.ContinuousDrillingObligations_TargetFormation = Helpers.createClassArray(ContinuousDrillingObligation, item.ContinuousDrillingObligations_TargetFormation);
      this.FormationTops_TargetFormation = Helpers.createClassArray(FormationTop, item.FormationTops_TargetFormation);
      this.LandingPoints_TargetFormation = Helpers.createClassArray(LandingPoint, item.LandingPoints_TargetFormation);
      this.TypeCurves_TargetFormation = Helpers.createClassArray(TypeCurve, item.TypeCurves_TargetFormation);
      this.Wells_TargetFormation = Helpers.createClassArray(Well, item.Wells_TargetFormation);
      this.AreaTargetFormations_TargetFormationAllowed = Helpers.createClassArray(AreaTargetFormation, item.AreaTargetFormations_TargetFormationAllowed);
      this.AutoMappingCombiningTargetFormations_CombiningTargetFormation = Helpers.createClassArray(AutoMappingCombiningTargetFormation, item.AutoMappingCombiningTargetFormations_CombiningTargetFormation);
      this.AutoRelationships_PrecedingFracGroupTargetFormation = Helpers.createClassArray(AutoRelationship, item.AutoRelationships_PrecedingFracGroupTargetFormation);
      this.AutoRelationships_SucceedingFracGroupTargetFormation = Helpers.createClassArray(AutoRelationship, item.AutoRelationships_SucceedingFracGroupTargetFormation);
      this.ConstraintDrillFracInterferenceInteractingTargetFormations_InteractingTargetFormation = Helpers.createClassArray(ConstraintDrillFracInterferenceInteractingTargetFormation, item.ConstraintDrillFracInterferenceInteractingTargetFormations_InteractingTargetFormation);
      this.ConstraintPrematureWellShutdownInteractingTargetFormations_InteractingTargetFormation = Helpers.createClassArray(ConstraintPrematureWellShutdownInteractingTargetFormation, item.ConstraintPrematureWellShutdownInteractingTargetFormations_InteractingTargetFormation);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
    }
  }
}